module.exports = __webpack_public_path__ + "img/tent-pitches-no.7773896.svg";